export default {
  codename: "",
  description: "",
  file: {
    type: "EVU",
    version: "2.00",
    logs_keeper: true,
    logs_keeper_config: {
      bandwidth: "10M",
      period: "60",
    },
    video_proxy: true,
    mixer2: true,
    fluentbit: true,
    output_fps: 30,
    output_size: 1080,
  },
  test: true,
};
